// @ts-nocheck
// Aplica a config injetada no runtime do container (config.json) sobre a config pública de build.
export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig();
  const base = (config.app?.baseURL || '/').replace(/\/$/, '');

  try {
    const runtime = await $fetch(`${base}/config.json`, { cache: 'no-cache' });
    if (runtime && typeof runtime.bffBase === 'string' && runtime.bffBase.trim()) {
      config.public.bffBase = runtime.bffBase;
    }
  } catch {
    // config.json ausente (ex.: dev local) — mantém o valor definido no build
  }
});
